module.exports = __webpack_public_path__ + "img/20190802132837122.dc728bbd.png";